import React, { useEffect, useState } from "react";
import "./smsForm.css";
import {
    getAllSms,
    createSms,
    updateSms,
    deleteSms,
    resetForm,
} from "../services/smsService";

function SmsForm() {
    const [form, setForm] = useState(resetForm());
    const [data, setData] = useState([]);
    const [editId, setEditId] = useState(null);
    const [viewMode, setViewMode] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const res = await getAllSms();
        setData(res);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({ ...form, [name]: type === "checkbox" ? checked : value });
    };

    const handleSave = async () => {
        if (!form.companyName || !form.username) return alert("Required fields missing");

        if (editId) {
            await updateSms(editId, form);
        } else {
            await createSms(form);
        }

        await loadData();
        handleClear();
    };

    const handleEdit = (item) => {
        setForm({ ...item });
        setEditId(item.sno);
        setViewMode(false);
    };

    const handleView = (item) => {
        setForm({ ...item });
        setViewMode(true);
        setEditId(null);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Delete this record?")) {
            await deleteSms(id);
            await loadData();
        }
    };

    const handleClear = () => {
        setForm(resetForm());
        setEditId(null);
        setViewMode(false);
    };

    return (
        <div className="page">

            {/* HEADER */}
            <div className="header-card">
                <h2>📩 SMS Configuration Panel</h2>
                <p>Create and manage SMS API configurations</p>
            </div>

            {/* FORM CARD */}
            <div className="card">

                <div className="form-grid">

                    <div className="form-group">
                        <label>Company Name</label>
                        <input
                            name="companyName"
                            value={form.companyName}
                            onChange={handleChange}
                            disabled={viewMode}
                        />
                    </div>

                    <div className="form-group">
                        <label>Username</label>
                        <input
                            name="username"
                            value={form.username}
                            onChange={handleChange}
                            disabled={viewMode}
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            disabled={viewMode}
                        />
                    </div>

                    <div className="form-group">
                        <label>SMS URL</label>
                        <input
                            name="smsUrl"
                            value={form.smsUrl}
                            onChange={handleChange}
                            disabled={viewMode}
                        />
                    </div>
                </div>

                {/* ACTIVE SWITCH */}
                <div className="checkbox">
                    <input
                        type="checkbox"
                        name="active"
                        checked={form.active}
                        onChange={handleChange}
                        disabled={viewMode}
                    />
                    <label>Active Configuration</label>
                </div>

                {/* BUTTONS */}
                {!viewMode && (
                    <div className="button-group">
                        <button className="button save" onClick={handleSave}>
                            {editId ? "Update" : "Save"}
                        </button>

                        <button className="button clear" onClick={handleClear}>
                            Clear
                        </button>
                    </div>
                )}
            </div>

            {/* TABLE CARD */}
            <div className="card">

                <h3>📋 Configuration List</h3>

                <table className="table">
                    <thead>
                        <tr>
                            <th>Company</th>
                            <th>Username</th>
                            <th>Password</th>
                            <th>URL</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((item) => (
                            <tr key={item.sno}>
                                <td>{item.companyName}</td>
                                <td>{item.username}</td>
                                <td>{"•".repeat(item.password?.length || 6)}</td>
                                <td className="url-cell">{item.smsUrl}</td>

                                <td>
                                    <span className={item.active ? "badge active" : "badge inactive"}>
                                        {item.active ? "Active" : "Inactive"}
                                    </span>
                                </td>

                                <td>
                                    <div className="action-buttons">
                                        <button onClick={() => handleView(item)}>View</button>
                                        <button onClick={() => handleEdit(item)}>Edit</button>
                                        <button onClick={() => handleDelete(item.sno)}>Delete</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    );
}

export default SmsForm;